import React from 'react';
import { MultiWebClientSubItemModel } from '@/User/domain';
import { MasterTruncatedTooltip } from '../MasterTruncatedTooltip';
import { DROPDOWN_STYLES } from '../constants/masterStyles';

interface SubItemProps {
  subItem: MultiWebClientSubItemModel;
  isHovered: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
}

/**
 * Componente atómico para mostrar un sub-item (sucursal) en la lista.
 * Incluye nombre truncado con tooltip, CIF y código.
 * 
 * @param subItem - Datos del sub-item a mostrar
 * @param isHovered - Indica si el item está siendo hovereado
 * @param onMouseEnter - Función para manejar el hover
 * @param onMouseLeave - Función para manejar cuando sale del hover
 * @param onClick - Función para manejar el clic
 */
export const MasterSubItem: React.FC<SubItemProps> = ({
  subItem,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        ...DROPDOWN_STYLES.subItemBase,
        background: isHovered ? '#F1F5F9' : 'transparent',
      }}
    >
      <span style={DROPDOWN_STYLES.subItemSpacer} />
      <span style={DROPDOWN_STYLES.subItemContent}>
        <MasterTruncatedTooltip text={subItem.name} />
        <span style={DROPDOWN_STYLES.subItemDetails}>
          {subItem.cif} - {subItem.code}
        </span>
      </span>
    </div>
  );
};
